/**
 * Prefix of the keys the Auth0 SPA SDK owns in localStorage: the access/refresh
 * token cache and the cross-tab refresh lock. Wiping these mid-session strands
 * the SDK and can cause refresh-token reuse / forced logouts (LAR-290), so
 * non-logout cleanups must preserve them. Only a real logout (after
 * `auth0.logout()`) should clear everything.
 */
const AUTH0_KEY_PREFIX = "@@auth0spajs@@";

/**
 * Prefix for settings the user chose deliberately — a saved table sort, say —
 * as opposed to the caches everything else under localStorage holds. The wipe
 * below runs on every deploy, so a preference stored outside this prefix is
 * quietly reset a few times a week and never feels saved (LAR-132).
 */
export const USER_PREFERENCE_KEY_PREFIX = "lara-law:preference:";

/**
 * Clears every localStorage entry except the Auth0 SDK's own cache/lock keys
 * and the user's saved preferences.
 * Use for non-logout cleanups (auth-error redirect, app-version cache busting).
 */
export const clearAppLocalStorage = (): void => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (
      key &&
      !key.startsWith(AUTH0_KEY_PREFIX) &&
      !key.startsWith(USER_PREFERENCE_KEY_PREFIX)
    ) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
};
